<script setup lang="ts">
import { ref } from "vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import { useConfirmKeys } from "@/composables/useConfirmKeys";

const props = defineProps<{
	type: 'chat' | 'group'
	name: string
}>()

const emit = defineEmits<{
	(e: 'cancel'): void,
	(e: 'confirm'): void,
}>()

const $root = ref<HTMLElement | null>(null)

useConfirmKeys({
	content: $root,
	cancel: () => emit('cancel'),
	confirm: () => emit('confirm'),
})
</script>

<template>
	<div ref="$root" class="dialog-delete-confirm">
		<div class="dialog-delete-confirm__title">
			{{ $t(props.type === 'chat' ? 'chat_delete_title' : 'chat_delete_group_title') }}
		</div>
		<div class="dialog-delete-confirm__description">
			<template v-if="props.type === 'chat'">
				{{ $t('chat_delete_user_prefix') }}
				<span class="dialog-delete-confirm__description-name">{{ name }}</span> {{ $t('delete_no_restore_suffix') }}
			</template>
			<template v-else>
				{{ $t('chat_delete_group_prefix') }}
				<span class="dialog-delete-confirm__description-name">{{ name }}</span> {{ $t('delete_no_restore_suffix') }}
			</template>
		</div>
		<div class="dialog-delete-confirm__actions">
			<app-button
				class="dialog-delete-confirm__actions-button"
				type="secondary"
				:label="$t('cancel_short')"
				@click="emit('cancel')"
			/>
			<app-button
				class="dialog-delete-confirm__actions-button"
				:label="$t('confirm_short')"
				@click="emit('confirm')"
			/>
		</div>
	</div>
</template>

<style scoped lang="scss">
.dialog-delete-confirm {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
	padding: 12px;
	gap: 8px;

	&__title {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		line-height: 18px;
		font-weight: 600;
		color: #4D4D4D;
	}

	&__description {
		font-size: 14px;
		line-height: 18px;
		color: #4D4D4D;
		text-align: center;

		&-name {
			font-weight: 500;
		}
	}

	&__actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;

		&-button {
			flex: 1;
		}
	}
}
</style>
